import {forwardRef, type ButtonHTMLAttributes} from "react";
import {Loader} from "@mantine/core";
import classes from "./modalStyles.module.css";

type ModalButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
    loading?: boolean;
};

export const PrimaryButton = forwardRef<HTMLButtonElement, ModalButtonProps>(
    ({loading, children, disabled, ...rest}, ref) => (
        <button
            ref={ref}
            type="button"
            className={classes.primaryButton}
            disabled={disabled || loading}
            {...rest}
        >
            {loading ? <Loader size="xs" color="white" /> : children}
        </button>
    ),
);
PrimaryButton.displayName = "PrimaryButton";

export const SecondaryButton = forwardRef<HTMLButtonElement, ModalButtonProps>(
    ({children, ...rest}, ref) => (
        <button
            ref={ref}
            type="button"
            className={classes.secondaryButton}
            {...rest}
        >
            {children}
        </button>
    ),
);
SecondaryButton.displayName = "SecondaryButton";

export const DestructiveButton = forwardRef<HTMLButtonElement, ModalButtonProps>(
    ({loading, children, disabled, ...rest}, ref) => (
        <button
            ref={ref}
            type="button"
            className={classes.destructiveButton}
            disabled={disabled || loading}
            {...rest}
        >
            {loading ? <Loader size="xs" color="white" /> : children}
        </button>
    ),
);
DestructiveButton.displayName = "DestructiveButton";
